import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quotes, Star, ArrowRight } from "@phosphor-icons/react";
import { Reveal } from "../components/Reveal";
import { api } from "../lib/api";

export default function Opiniones() {
  const [items, setItems] = useState([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    api.get("/testimonials").then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (items.length === 0) return;
    const t = setInterval(() => setIndex((i) => (i + 1) % items.length), 6000);
    return () => clearInterval(t);
  }, [items]);

  if (items.length === 0) return null;
  const current = items[index];

  return (
    <section id="opiniones" data-testid="opiniones-section" className="py-24 md:py-36 bg-white">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <p className="overline mb-8">
            <span className="text-[#D7C6A3]">08</span> &nbsp;/&nbsp; Opiniones
          </p>
          <Quotes size={48} weight="fill" className="text-[#A3B18A] mx-auto mb-8" />
        </Reveal>

        <div className="min-h-[220px] flex items-center justify-center">
          <AnimatePresence mode="wait">
            <motion.div
              key={current.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              data-testid="testimonial-active"
            >
              <p className="font-display text-2xl md:text-4xl text-[#2D3732] leading-snug font-light">
                “{current.text}”
              </p>
              <div className="flex items-center justify-center gap-1 mt-8">
                {Array.from({ length: current.rating }).map((_, i) => (
                  <Star key={i} size={18} weight="fill" className="text-[#D7C6A3]" />
                ))}
              </div>
              <p className="mt-5 text-[#2D3732] font-medium">{current.name}</p>
              <p className="text-sm text-[#6B705C]">{current.role}</p>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="flex items-center justify-center gap-3 mt-10">
          {items.map((_, i) => (
            <button
              key={i}
              data-testid={`testimonial-dot-${i}`}
              onClick={() => setIndex(i)}
              className={`h-1.5 rounded-full transition-all duration-500 ${
                i === index ? "w-8 bg-[#8A9A6F]" : "w-1.5 bg-[#D7C6A3]"
              }`}
              aria-label={`Ver opinión ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
